import { use } from "i18next";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useRef, useState } from "react";

import {
  Button,
  Card,
  CardHeader,
  UncontrolledTooltip,
  Container,
  Row,
  Col,
  Alert,
  Spinner,
} from "reactstrap";

import { useTranslation } from "react-i18next";

import { RootStoreContext } from "../../app/stores/rootStore";
import {
  formatCustomDate,
  translationHookOptions,
} from "../../app/localization/localization";
import {
  DownloadRecordingTypes,
  DownloadRecordingZipSTatus,
} from "../../app/models/cabolo";
import InfoMessage from "../common/InfoMessage";
import Loader from "../common/Loader";
import LoaderModal from "../common/LoaderModal";
import GenericConfirmModal from "../common/GenericConfirmModal";
import ProtectedCaboloDownload from "../common/ProtectedCaboloDownload";

interface IParams {
  meetingId: number;
  handleActionDownload: (filename: string, href: string) => void;
}

const CaboloRecordingMeetingComponent: React.FC<IParams> = ({
  meetingId,
  handleActionDownload,
}) => {
  const [t] = useTranslation(["cabolo"], translationHookOptions);
  const rootStore = useContext(RootStoreContext);
  const { currentTenant } = rootStore.tenantStore;
  const { theme } = rootStore.commonStore;
  const {
    loadTranscriptionCabolo,
    loadingRecordingMeetingCaboloPage,
    recordingMeetingCaboloPageDto,
    resetRecordingMeetingCaboloPage,
    deleteRecordingMeetingCabolo,
  } = rootStore.caboloStore;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isModalDeleteElements, setIsModalDeleteElements] = useState(false);
  const [isModalLoader, setIsModalLoader] = useState(false);

  const [selectedElements, setSelectedElements] = useState<number[]>([]);

  useEffect(() => {
    if (meetingId <= 0) return;

    loadTranscriptionCabolo(meetingId);
    return () => {
      resetRecordingMeetingCaboloPage();
    };
  }, [meetingId, loadTranscriptionCabolo, resetRecordingMeetingCaboloPage]);

  const clickDeleteRecording = (e: any, id: number, hasMeeting: boolean) => {
    selectedElements.length = 0;
    selectedElements.push(id);
    setSelectedElements(selectedElements);
    setIsDeleteModalOpen(true);
  };

  const TitleFormatter = (cell: any) => {
    return (
      <>
        <div className="node-title">{cell}</div>
      </>
    );
  };
  const dateFormatter = (cell: any) => {
    let format = "";
    if (cell) format = formatCustomDate(cell);
    return <span> {format}</span>;
  };

  const durationFormatter = (cell: any) => {
    if (!cell) return "";
    const totalSeconds = Math.floor(cell); // Tronca i millisecondi
    // Se la durata è in secondi
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    // Restituisci la durata formattata in HH:mm:ss
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  const sizeFormatter = (cell: any) => {
    if (!cell && cell !== 0) return "";
    const sizeInMB = cell / (1024 * 1024); // Converti i byte in megabyte
    return `${sizeInMB.toFixed(2)} MB`;
  };

  const StatusFormatter = (cell: any, index: any) => {
    const tooltipId = `tooltipWrapper${index}`;
    let iconClass = "fas fa-sync fa-lg";
    let colorClass = "";
    let isSpinning = false;
    let tooltipText = "";

    switch (cell) {
      case DownloadRecordingZipSTatus.STATE_READY:
        iconClass = "fas fa-sync fa-lg";
        colorClass = "text-green";
        tooltipText = t("sync_downloadZip_success", { ns: "cabolo" });
        break;
      case DownloadRecordingZipSTatus.STATE_IN_PROGRESS:
        iconClass = "fas fa-sync fa-lg";
        colorClass = "text-orange";
        isSpinning = true;
        tooltipText = t("sync_downloadZip_progress", { ns: "cabolo" });
        break;
      case DownloadRecordingZipSTatus.STATE_ERROR:
        iconClass = "fas fa-exclamation-circle fa-lg";
        colorClass = "text-danger";
        tooltipText = t("sync_downloadZip_error", { ns: "cabolo" });
        break;
      case DownloadRecordingZipSTatus.STATE_HOLD_ON:
        iconClass = "fas fa-sync fa-lg";
        colorClass = "text-default";
        tooltipText = t("syncRecordingMeeting", { ns: "button" });
        break;
      default:
        return null;
    }

    return (
      <>
        <span id={tooltipId}>
          <i
            className={`${iconClass} ${
              isSpinning ? "fa-spin" : ""
            } ${colorClass}`}
          ></i>
        </span>
        <UncontrolledTooltip delay={0} placement="top" target={tooltipId}>
          {tooltipText}
        </UncontrolledTooltip>
      </>
    );
  };

  const editFormatter = (row: any, index: any) => {
    return (
      <>
        <div style={{ textAlign: "right" }}>
          {recordingMeetingCaboloPageDto?.canDownloadZipTranscription && (
            <>
              <ProtectedCaboloDownload
             
                hasLoaderModal={true}
                url={`/cabolo/recordingsMeeting/download/${row.id}?format=${DownloadRecordingTypes.Zip}`}
                disabled={
                  row.statusDownloadZip ===
                  DownloadRecordingZipSTatus.STATE_READY
                    ? false
                    : true
                }
                handleActionDownload={handleActionDownload}
              >
                <Button
                 style={{paddingLeft: "0px"}}
                  disabled={
                    row.statusDownloadZip ===
                    DownloadRecordingZipSTatus.STATE_READY
                      ? false
                      : true
                  }
                  id={`btnNodeDownloadZip_${index}`}
                  className="buttonNoPadding"
                  color="link"
                >
                  <i className="fas fa-download fa-lg  text-default"></i>
                </Button>
                <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target={`btnNodeDownloadZip_${index}`}
                >
                  {t("download_zip", { ns: "cabolo" })}
                </UncontrolledTooltip>
              </ProtectedCaboloDownload>
            </>
          )}

          {recordingMeetingCaboloPageDto?.canDownloadDocTranscription && (
            <>
              <ProtectedCaboloDownload
                hasLoaderModal={true}
                url={`/cabolo/recordingsMeeting/download/${row.id}?format=${DownloadRecordingTypes.Docx}`}
                disabled={
                  row.statusDownloadZip ===
                  DownloadRecordingZipSTatus.STATE_READY
                    ? false
                    : true
                }
                handleActionDownload={handleActionDownload}
              >
                <Button
                  disabled={
                    row.statusDownloadZip ===
                    DownloadRecordingZipSTatus.STATE_READY
                      ? false
                      : true
                  }
                  id={`btnNodeDownloadDoc_${index}`}
                  className="buttonNoPadding"
                  color="link"
                >
                  <i className="fas fa-file-word fa-lg  text-default"></i>
                </Button>
                <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target={`btnNodeDownloadDoc_${index}`}
                >
                  {t("download_document", { ns: "cabolo" })}
                </UncontrolledTooltip>
              </ProtectedCaboloDownload>
            </>
          )}
          {recordingMeetingCaboloPageDto?.canDownloadAudioVideoTranscription && (
            <>
              <ProtectedCaboloDownload
                hasLoaderModal={true}
                url={`/cabolo/recordingsMeeting/download/${row.id}?format=${DownloadRecordingTypes.Audio}`}
                disabled={
                  row.statusDownloadZip ===
                  DownloadRecordingZipSTatus.STATE_READY
                    ? false
                    : true
                }
                handleActionDownload={handleActionDownload}
              >
                <Button
                  disabled={
                    row.statusDownloadZip ===
                    DownloadRecordingZipSTatus.STATE_READY
                      ? false
                      : true
                  }
                  id={`btnNodeDownloadAudio_${index}`}
                  className="buttonNoPadding"
                  color="link"
                >
                  <i className="fas fa-file-audio fa-lg  text-default"></i>
                </Button>
                <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target={`btnNodeDownloadAudio_${index}`}
                >
                  {t("download_audio_video", { ns: "cabolo" })}
                </UncontrolledTooltip>
              </ProtectedCaboloDownload>
            </>
          )}
          {recordingMeetingCaboloPageDto?.canManageTranscriptions && (
            <>
              <Button
                disabled={
                  row.statusDownloadZip ===
                  DownloadRecordingZipSTatus.STATE_IN_PROGRESS
                }
                className="buttonNoPadding"
                id={`lnkDelete_${row.id}`}
                color="link"
                onClick={(e: any) => {
                  clickDeleteRecording(e, row.id, row.meetingId);
                }}
              >
                <i className="fas fa-trash-alt fa-lg text-danger"></i>
              </Button>
              <UncontrolledTooltip
                delay={0}
                placement="top"
                target={`lnkDelete_${row.id}`}
              >
                {t("delete", { ns: "button" })}
              </UncontrolledTooltip>
            </>
          )}
        </div>
      </>
    );
  };

  if (
    recordingMeetingCaboloPageDto &&
    recordingMeetingCaboloPageDto.recordings.length == 0
  )
    return (
      <Row>
        <Col xs={12}>
          <InfoMessage
            color="primary"
            message={t("empty_recordings", { ns: "cabolo" })}
            icon="fas fa-globe fa-3x"
          />
        </Col>
      </Row>
    );

  if (loadingRecordingMeetingCaboloPage) return <Loader></Loader>;

  return (
    <>
      <div className="col" style={{ paddingLeft: "0px" }}></div>
      {recordingMeetingCaboloPageDto?.recordings.map((recording, index) => (
        <>
{/* <li
  key={recording.id}
  className="list-group-item d-flex flex-column"
>
  <div className="d-flex align-items-center mb-2">
    <span
      className="badge rounded-pill flex-shrink-0 me-2"
      style={{ whiteSpace: "nowrap" }}
    >
      {StatusFormatter(recording.statusDownloadZip, index)}
    </span>

    <div className="text-truncate" style={{ flex: 1, fontWeight: 'bold' }}>
      {recording.title}
    </div>
  </div>
  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
    <div className="me-md-3 mb-3 mb-md-0">
      <small className="">
        {t("file_startDate", { ns: "cabolo" })}: {dateFormatter(recording.startDate)} <br />
        {t("file_endDate", { ns: "cabolo" })}: {dateFormatter(recording.endDate)} <br />
        {t("file_duration", { ns: "cabolo" })}: {durationFormatter(recording.duration)} <br />
        {t("file_size", { ns: "cabolo" })}: {sizeFormatter(recording.size)} <br />
      </small>
    </div>

    <div className="d-flex flex-wrap justify-content-end gap-2">
      {editFormatter(recording, index)}
    </div>
  </div>
</li> */}

{/* <li
  key={recording.id}
  className="d-flex flex-column position-relative mb-3 border border-2 rounded p-3"
>
  <span
    className="badge rounded-pill position-absolute"
    style={{ top: '0.5rem', left: '0.5rem', whiteSpace: 'nowrap' }}
  >
    {StatusFormatter(recording.statusDownloadZip, index)}
  </span>
  <div className="mb-2 text-center w-100">
    <div className="fw-bold text-truncate d-inline-block" style={{ maxWidth: '90%' , fontWeight: 'bold'}}>
      {recording.title}
    </div>
  </div>
  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
    <div className="me-md-3 mb-3 mb-md-0">
      <small className="">
        {t("file_startDate", { ns: "cabolo" })}: {dateFormatter(recording.startDate)} <br />
        {t("file_endDate", { ns: "cabolo" })}: {dateFormatter(recording.endDate)} <br />
        {t("file_duration", { ns: "cabolo" })}: {durationFormatter(recording.duration)} <br />
        {t("file_size", { ns: "cabolo" })}: {sizeFormatter(recording.size)} <br />
      </small>
    </div>

    <div className="d-flex flex-wrap justify-content-end gap-2">
      {editFormatter(recording, index)}
    </div>
  </div>
</li> */}
{/* <li
  key={recording.id}
  className="d-flex flex-column position-relative mb-3 border border-2 rounded p-3"
>
  <span
    className="badge rounded-pill position-absolute"
    style={{ top: '0.5rem', left: '0.5rem', whiteSpace: 'nowrap' }}
  >
    {StatusFormatter(recording.statusDownloadZip, index)}
  </span>
  <div className="mb-2 text-center w-100">
    <div className="fw-bold text-truncate d-inline-block" style={{ maxWidth: '90%', fontWeight:"bold" }}>
      {recording.title}
    </div>
  </div>
  <div className="d-flex flex-column align-items-center">
    <div className="text-start" style={{ maxWidth: "90%" }}>
      <small className="mb-3 d-block">
        {t("file_startDate", { ns: "cabolo" })}: {dateFormatter(recording.startDate)} <br />
        {t("file_endDate", { ns: "cabolo" })}: {dateFormatter(recording.endDate)} <br />
        {t("file_duration", { ns: "cabolo" })}: {durationFormatter(recording.duration)} <br />
        {t("file_size", { ns: "cabolo" })}: {sizeFormatter(recording.size)} <br />
      </small>
    </div>
    <div className="d-flex flex-wrap">
        {editFormatter(recording, index)}
      </div>
  </div>
</li> */}
<li
style={{ borderWidth: '1px', borderStyle: 'solid' }}
  key={recording.id}
  className="d-flex flex-column position-relative mb-3  rounded p-3"
>
  {/* Badge in alto a sinistra */}
  <span
    className="badge rounded-pill position-absolute"
    style={{ top: '0.5rem', left: '0.5rem', whiteSpace: 'nowrap' }}
  >
    {StatusFormatter(recording.statusDownloadZip, index)}
  </span>

  {/* Titolo centrato */}
  <div className="mb-2 text-center w-100">
    <div
      className="fw-bold text-truncate d-inline-block"
      style={{ maxWidth: '90%', fontWeight: 'bold' }}
    >
      {recording.title}
    </div>
  </div>

  {/* Dettagli e bottoni: centrati a sinistra */}
  <div style={{ maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto' }}>
    <div className="text-start mb-3">
      <small>
        {t("file_startDate", { ns: "cabolo" })}: {dateFormatter(recording.startDate)} <br />
        {t("file_endDate", { ns: "cabolo" })}: {dateFormatter(recording.endDate)} <br />
        {t("file_duration", { ns: "cabolo" })}: {durationFormatter(recording.duration)} <br />
        {t("file_size", { ns: "cabolo" })}: {sizeFormatter(recording.size)} <br />
      </small>
    </div>

    <div className="d-flex flex-wrap gap-2">
      {editFormatter(recording, index)}
    </div>
  </div>
</li>
        </>
      ))}

      <GenericConfirmModal
        title=""
        showCancelButton={true}
        messages={t("delete_recording", { ns: "cabolo" })}
        isOpen={isDeleteModalOpen}
        toggle={() => {
          setIsDeleteModalOpen(!isDeleteModalOpen);
        }}
        action={() => {
          setIsModalLoader(true);
          deleteRecordingMeetingCabolo(selectedElements[0])
            .then(() => {
              setSelectedElements([]);
              setIsDeleteModalOpen(false);
              setIsModalLoader(false);
            })
            .catch((error) => {
              console.error("Error deleting recording:", error);
              setIsModalLoader(false);
            })
            .finally(() => {
              loadTranscriptionCabolo(meetingId);
            });
        }}
      />
      <LoaderModal
        size="sm"
        title={""}
        //  backdrop="static"
        //  keyboard={false}
        isOpen={isModalLoader}
        message={t("waiting", { ns: "features" })}
        toggle={() => {
          setIsModalLoader(false);
        }}
      ></LoaderModal>
    </>
  );
};
export default observer(CaboloRecordingMeetingComponent);
